import styled from '@emotion/styled'
import { Button } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const ButtonStyled = styled(Button)`
  width: ${theme.spacing['2xm']};
  min-width: min-content;
  height: ${theme.spacing['2xm']};
  padding: 0;
  border-radius: ${theme.shapes.borderRadius.sm};
  background: ${theme.colors.neutral.white};

  &:disabled {
    cursor: default;
  }
`
